<template>
  <div id="anli">
    <div class="anli-img content"></div>
    <div class="weCase">
      <el-row :gutter="30">
        <el-col
          :xs="24"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="8"
          v-for="(item, index) in successCase"
          :key="index"
          style="margin-bottom:2rem"
        >
          <div class="caseItem" @click="lookDetail(item.id)">
            <div class="imgBox">
                <img :src="item.src" alt="" class="caseImg" />
                <div class="overlay"></div>
                <div class="caseTime">建成时间： {{ item.time }}</div>
            </div>
            <div class="bottomInfo">
              <div class="caseName">{{ item.name }}</div>
            </div>
            <div class="tagRow">
                <div class="commonStyle" :class="n.class" v-for="(n,i) in item.tagData" :key="i">{{n.tagName}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="case-card content">
      <first-part id="firstPart" />
      <second-part id="secondPart" />
      <third-part id="thirdPart" />
      <four-part id="fourPart" />
      <five-part id="fivePart" />
      <six-part id="sixPart" />
    </div>

    <div class="bottomRow">
      <div
        class="countPanel wow animate__zoomIn"
        v-for="(item, index) in bottomPanelData"
        :key="index"
      >
        <div class="panelCount">{{ item.count }}</div>
        <div class="panelTitle">{{ item.desc }}</div>
      </div>
    </div>

    
  </div>
</template>

<script>
import firstPart from "@/components/caseImg/firstPart";
import secondPart from "@/components/caseImg/secondPart";
import thirdPart from "@/components/caseImg/thirdPart";
import fourPart from "@/components/caseImg/fourPart";
import fivePart from "@/components/caseImg/fivePart";
import sixPart from "@/components/caseImg/sixPart";
export default {
  props: {},
  data() {
    return {
      successCase: [
        {
          id: "firstPart",
          name: "高铁南京南站",
          time: "2018年",
          src:require('../../assets/img/home/njn.png'),
          tagData:[
            {tagName:'智慧消防',class:'xf'},
            {tagName:'智慧用电',class:'yd'},
            {tagName:'智慧巡检',class:'xj'},
          ]
        },
        {
          id: "secondPart",
          name: "杭甬高速铁路",
          time: "2019年",
          src:require('../../assets/img/home/hyx.png'),
          tagData:[
            {tagName:'智慧消防',class:'xf'},
            {tagName:'智慧用电',class:'yd'},
            {tagName:'智慧巡检',class:'xj'},
            {tagName:'视频RTC',class:'rtc'},
          ]
        },
        {
          id: "thirdPart",
          name: "南京动车段",
          time: "2020年-2021年",
          src:require('../../assets/img/home/dcd.png'),
          tagData:[
            {tagName:'智慧消防',class:'xf'},
            {tagName:'智慧用电',class:'yd'},
            {tagName:'智慧巡检',class:'xj'},
            {tagName:'视频RTC',class:'rtc'},
            {tagName:'视频识别',class:'sb'},
          ]
        },
        {
          id: "fourPart",
          name: "南京桥工段",
          time: "2020年",
          src:require('../../assets/img/home/qgd.png'),
          tagData:[
            {tagName:'独立感知',class:'xj'},
            {tagName:'智慧巡检',class:'xj'},
          ]
        },
        {
          id: "fivePart",
          name: "南京电务段",
          time: "2020年",
          src:require('../../assets/img/home/dwd.png'),
          tagData:[
            {tagName:'视频RTC',class:'rtc'},
            {tagName:'视频识别',class:'sb'},
          ]
        },
        {
          id: "sixPart",
          name: "吉美思物联网产业园",
          time: "2021年",
          src:require('../../assets/img/home/jms.png'),
          tagData:[
            {tagName:'智慧消防',class:'xf'},
            {tagName:'智慧用电',class:'yd'},
            {tagName:'智慧巡检',class:'xj'},
            {tagName:'视频RTC',class:'rtc'},
            {tagName:'视频识别',class:'sb'},
          ]
        },
      ],
      bottomPanelData: [
        { count: "40+", desc: "园区企业" },
        { count: "100+", desc: "视频" },
        { count: "1000+", desc: "消防点位" },
      ],
      activeIndex: -1,
      receiveCate:'',
    };
  },
  computed: {},

  mounted() {
    let cateId = this.$route.params.category;
    if (cateId == undefined) {
      return false;
    }
    if (cateId == 1) {
      this.receiveCate = "firstPart";
    } else if (cateId == 2) {
      this.receiveCate = "secondPart";
    } else if (cateId == 3) {
      this.receiveCate = "thirdPart";
    }else if (cateId == 4) {
      this.receiveCate = "fourPart";
    }else if (cateId == 5) {
      this.receiveCate = "fivePart";
    }else if (cateId == 6) {
      this.receiveCate = "sixPart";
    }
    this.lookDetail(this.receiveCate);
  },
  watch: {},
  methods: {
    lookDetail(idName) {
      let height = this.$el.querySelector("#" + idName).offsetTop - 200;
      window.scroll({ top: height, left: 0, behavior: "smooth" });
    },
  },
  components: {
    firstPart,
    secondPart,
    thirdPart,
    fourPart,
    fivePart,
    sixPart
  },
};
</script>

<style  lang="scss" scoped>
.content {
  box-sizing: border-box;
}
.anli-img {
  height: 50rem;
  background-image: url("../../assets/img/case/caseBanner.png");
  background-position: center;
  background-size: 100% 100%;
  position: relative;
}
.weCase {
  background: #f6f8fa;
  padding: 5% 14%;
  .caseItem {
    position: relative;
    border-radius: 1rem;
    height: 30rem;
    margin-bottom: 4rem;
    cursor: pointer;
    .imgBox{
        height: 24rem;
        overflow: hidden;
        position: relative;
    }
    &:hover {
      .overlay {
        opacity: 1;
        height: 100%;
        transform: scale(1.1);
      }
      .caseImg {
        height: 100%;
        transform: scale(1.1);
      }
    }
    .overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.5);
      opacity: 0;
      z-index: 2;
      transition: all 0.5s;
    }
    .caseImg {
      height:100%;
      width: 100%;
      border-radius: 1rem 1rem 0 0;
      position: absolute;
      top: 0;
      left: 0;
      transition: all 0.5s;
      object-fit: cover;
    }
    .caseTime {
      background: linear-gradient(125deg, #00b7a4, #0dca81);
      border-radius: 4px 0px 4px 0px;
      color: #ffffff;
      font-size: 1.4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      height: 4rem;
      padding: 1rem 2rem;
    }
    .bottomInfo {
      .caseName {
        font-size: 1.8rem;
        font-weight: bold;
        color: #333333;
        margin: 1rem 0;
      }
    }
    .tagRow{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        .commonStyle{
            width: 8rem;
            margin-right: 5px;
            height: 2.8rem;
            text-align: center;
            line-height: 2.8rem;
            font-size: 12px;
            font-weight: bold;
            border-radius: 4px;
        }
        .xf{
            background: #FEFCF7;
            color: #EDA637;
        }
        .yd{
            background: #FEFCF7;
            color: #EDA637;
        }
        .xj{
           color: #00B7A4;
            background:#F5FCFB ;
        }
        .rtc{
           color: #038EF9;
            background:#F5FBFF ;
        }
        .sb{
           color: #038EF9;
            background:#F5FBFF ;
        }
    }
  }
}
.bottomRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    height: 20rem;
    background:url('../../assets/img/case/jmsbg.png') ;
    background-size: 100% 100%;
    width: 100%;
    padding: 0 10%;
    .countPanel {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      width: 32%;
      height: 12rem;
      .panelCount {
        font-weight: bold;
        line-height: 2.4rem;
        font-size: 2.4rem;
        color: #ffffff;
      }
      .panelTitle {
        line-height: 2.4rem;
        font-size: 1.4rem;
        margin-top: 2rem;
        color: #ffffff;
      }
    }
  }

@import '../../assets/responsive/case.scss'
</style>
